module.exports = __webpack_public_path__ + "static/media/WinkSF.3fcd922c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/stores/WinkSF.jpg
 ** module id = 474
 ** module chunks = 0
 **/